import { formatDate } from '@angular/common';
import { HttpHeaders, HttpParams } from '@angular/common/http';
import { AfterViewChecked, Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder } from '@angular/forms';
import { AssociatedID, ChangeDatetimeReshopReprice, Passenger as orderRePricePassenger } from 'src/app/model/request/change-date-time-reshop-reprice-request';
import {
  CabinType,
  OrderItem as changeBookingOrderItem,
  OrderReshopChangeDatetime,
  OriginDestination as changeBookingOriginDestination,
  Passenger as orderReshopPassenger
} from 'src/app/model/request/change-date-time-screen-request';
import { FindOrderScreenRequest } from 'src/app/model/request/find-order-screen-request';
import { OfferPriceScreenOrderCreateRequest } from 'src/app/model/request/offer-price-screen-order-create-request';
import { OfferItem as changeBookingOfferItem, OrderChangeChangeDatetimeRQ } from 'src/app/model/request/order-change-change-date-time-screen-request';
import { AddAncilliariesScreen } from 'src/app/model/screen/add-ancilliaries-screen';
import {
  AirlineFilter,
  AirlineOffer,
  AirlineOfferBase,
  AirlineOfferFlightDetail,
  BoundAirlineOffer,
  ChangeBookingAirlineOfferBase,
  ChangeBookingPassenger as changeBookingPassenger,
  ChangeFlightDateTimeScreen,
  FlightDetail,
  OfferItems,
  Passenger,
  PriceDetail
} from 'src/app/model/screen/change-flight-date-time-screen';
import { ReshopPassenger } from 'src/app/model/screen/confirm-booking-screen';
import { Passenger as PassengerDetailSceenPassenger, Passenger as PassengerDetailsScreenPassenger, PassengerDetailScreen } from 'src/app/model/screen/passenger-detail-screen';
import { YourBookingScreen } from 'src/app/model/screen/your-booking-screen';
import { DateFormatPipe } from 'src/app/pipe/date-format.pipe';
import { ApiService } from 'src/app/service/api.service';
import { ContentfulService } from 'src/app/service/contentful.service';
import { LocalAssetReaderService } from 'src/app/service/local-asset-reader.service';
import { SandboxPageStateService } from 'src/app/service/sandbox-page-state.service';
import { XmlToJsonParserService } from 'src/app/service/xml-to-json-parser.service';
import reQuoteTicketJSON from 'src/assets/json/order-change/request/requote-ticket-default-params.json';
import orderRepriceJSON from 'src/assets/json/order-reshop/reprice/request/reprice-request-default-params.json';

@Component({
  selector: 'app-change-flight-date-time',
  templateUrl: './change-flight-date-time.component.html',
  styleUrls: ['./change-flight-date-time.component.scss']
})
export class ChangeFlightDateTimeComponent implements OnInit {
  public changeDateTimeDeatils: any = [];
  flightDeatils: FlightDetail = {} as FlightDetail;
  outBoundDate: string = '';
  changeYourBookingScreendeatils: ChangeFlightDateTimeScreen = {} as ChangeFlightDateTimeScreen;
  orderChangeChangeDatetimeRQ: OrderReshopChangeDatetime = {} as OrderReshopChangeDatetime;
  changeBookingRepriceRQ: ChangeDatetimeReshopReprice = {} as ChangeDatetimeReshopReprice;
  passengerDetailScreen: PassengerDetailScreen = {} as PassengerDetailScreen;
  orderChangeChangeDateTime: OrderChangeChangeDatetimeRQ = {} as OrderChangeChangeDatetimeRQ;
  changeBookingForm: any;
  inputParamsMap = new Map();
  reQuoteTicketInputParamsMap = new Map();
  cabins = [
    { value: '0', cabin: 'No Cabin Change' },
    { value: '5', cabin: 'Economy' },
    { value: '4', cabin: 'Premium Economy' },
    { value: '2', cabin: 'Business' },
    { value: '1', cabin: 'First' }
  ];
  orderItems: any;
  public orderItemIds: any = [];
  public flightSegmentRefs: any = [];
  flightSegmentRefKey: any[] = [];
  public segmentList: any = [];
  public segmentListIds: any = [];
  public flightList: any = [];
  public flightListIds: any = [];
  public priceClassList: any = [];
  public priceClassListIds: any = [];
  public priceListIds: any = [];
  public fareList: any = [];
  public fareListIds: any = [];
  public descriptionList: any = [];
  public descriptionListIds: any = [];
  public rulesList: any = [];
  public rulesIds: any = [];
  public pNumberList: any = [];
  public passengersList: Passenger[] = [];
  public infantRefsIds: any[] = [];
  public adultRefsIds: any[] = [];
  public changeFeeInd: any;
  public refundableInd: any;
  public cancelFeeInd: any;
  flightLogoMap = new Map();
  remarkText: string = '';
  baggagesIds: any[] = [];
  orderItemArrayForDelete: any;
  public baggageList: any[] = [];
  public alphabetsOrderName = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'AA', 'AB', 'AC', 'AD', 'AE', 'AF'];
  public disabledGetOffer: boolean = true;
  public airlineFilterData: AirlineFilter = {
    airportList: [],
    operaterList: [],
    priceClassList: []
  };
  bags: any;
  //flightList: any;
  public flightSegment: any;
  isInboundAirlineOffers: boolean = false;
  public baCheckBag: boolean = true;
  selectedBoundOfferForChange: BoundAirlineOffer[] = [];
  public airlineOfferScreenResponseId = '';
  offerPriceDataList: any = [];
  offerPricePricedOffer: any = {};

  airlineLogos: [] = [];
  isSMEUser: boolean = false;

  constructor(
    private sandboxPageStateService: SandboxPageStateService,
    private datePipe: DateFormatPipe,
    private formBuilder: FormBuilder,
    private localAssetReaderService: LocalAssetReaderService,
    private apiService: ApiService,
    private xmlToJsonParserService: XmlToJsonParserService,
    private contentfulService: ContentfulService
  ) {
    const query = { 'fields.name': 'Airline Logos#SANDBOX' };
    this.contentfulService.getMenuContentWithItems(query).then((items) => {
      this.airlineLogos = items[0]?.fields.jsonData;
      if (this.airlineLogos && Object.keys(this.airlineLogos).length > 0) {
        Object.entries(this.airlineLogos).forEach((entry) => {
          const [key, value] = entry;
          this.flightLogoMap.set(key, value);
        });
      }
    });

    this.changeBookingForm = this.formBuilder.group({
      boundOffersArray: this.formBuilder.array([])
    });

    Object.entries(orderRepriceJSON).forEach((entry) => {
      const [key, value] = entry;
      this.inputParamsMap.set(key, value);
    });
    Object.entries(reQuoteTicketJSON).forEach((entry) => {
      const [key, value] = entry;
      this.reQuoteTicketInputParamsMap.set(key, value);
    });
  }
  inp_group(controlName: any) {
    return this.changeBookingForm.controls[controlName];
  }
  inp_array(controlName: any) {
    return this.inp_group(controlName) as FormArray;
  }
  makeOfferSelected(i: any) {
    let boundOffers = this.inp_array('boundOffersArray');
    let selectedOffer = boundOffers.at(i).value;
    let flagStatus = true;
    if (selectedOffer.isBoundSelected) {
      flagStatus = false;
    }
    this.inp_array('boundOffersArray').at(i).patchValue({
      isBoundSelected: flagStatus
    });
    let updateBoundOffers = this.inp_array('boundOffersArray').value;
    this.disabledGetOffer = true;
    updateBoundOffers.forEach((boundOffer: any) => {
      if (boundOffer.isBoundSelected) {
        this.disabledGetOffer = false;
      }
    });
  }
  selectedPNR: any;
  loggeduserMailID: any;
  current_timestamp: any;
  haveOcnNotificationDetail: boolean = false;

  ngOnInit(): void {
    this.isSMEUser = this.sandboxPageStateService.getUser().isSMEUser;
    let disrubtedOrderViewData = this.sandboxPageStateService.getYourBookingScreenData();

    if (disrubtedOrderViewData.haveOcnNotificationDetail === true) {
      this.haveOcnNotificationDetail = disrubtedOrderViewData.haveOcnNotificationDetail;
      this.current_timestamp = disrubtedOrderViewData.current_timestamp;
      this.selectedPNR = disrubtedOrderViewData.pnrNumber;
    }

    this.loggeduserMailID = this.sandboxPageStateService.getEncodedUserEmail();
    this.selectedPNR = this.sandboxPageStateService.getFindOrderFormValue();
    let changeFlightDateTimeScreen = this.sandboxPageStateService.getYourBookingScreenData();

    this.changeYourBookingScreendeatils.reshopAirlineOffers = [];
    this.changeDateTimeDeatils = changeFlightDateTimeScreen.booking;
    this.mapChangeDateTimeDetails(this.changeDateTimeDeatils);
    this.airlineOfferScreenResponseId = this.changeDateTimeDeatils.responseID;
  }

  mapChangeDateTimeDetails(changeDateTimeDeatils: any) {
    let boundAirlineOfferList: ChangeBookingAirlineOfferBase[] = [];

    changeDateTimeDeatils.boundAirlineOffer.forEach((offerItem: any) => {
      let boundAirlineOffer = {} as ChangeBookingAirlineOfferBase;
      let formattedDate = '';
      boundAirlineOffer.flightsDetails = this.mapflightDetails(offerItem.flightsDetails);
      boundAirlineOffer.depatureAirportCode = offerItem.depatureAirportCode;
      boundAirlineOffer.arrivalAirportCode = offerItem.arrivalAirportCode;
      boundAirlineOffer.depatureDate = offerItem.depatureDate;
      formattedDate = offerItem.depatureDate.split('-')[1] + '-' + offerItem.depatureDate.split('-')[0] + '-' + offerItem.depatureDate.split('-')[2];

      boundAirlineOfferList.push(boundAirlineOffer);
      //let formattedDate = new Date(offerItem.depatureDate).toISOString().replace(/T.*/, '').split('-').reverse().join('-');
      this.changeBookingForm.get('boundOffersArray').push(
        this.formBuilder.group({
          isBoundSelected: false,
          cabinPreference: '0',
          depatureDate: formatDate(formattedDate, 'yyyy-MM-dd', 'en'),
          originDestinationKey: offerItem.originDestinationKey,
          depatureAirportCode: boundAirlineOffer.flightsDetails[0].departureAirportCode,
          arrivalAirportCode: boundAirlineOffer.flightsDetails[boundAirlineOffer.flightsDetails.length - 1].arrivalAirportCode,
          airlineOffer: boundAirlineOffer
        })
      );
      // this.changeBookingForm.get('boundOffersArray').get('depatureDate').value=offerItem.depatureDate;
    });

    this.changeYourBookingScreendeatils.boundAirlineOfferList = boundAirlineOfferList;
  }
  mapflightDetails(changeDateflightDetails: any) {
    let flightsDetails: FlightDetail[] = [];
    changeDateflightDetails?.forEach((flightDeatils: any) => {
      this.flightDeatils = {
        airlineId: flightDeatils.airlineId,
        flightNumber: flightDeatils.airlineNumber,
        flightDuration: flightDeatils.duriation,
        flightTime: flightDeatils.departureTimeIn24H,
        flightDate: flightDeatils.departureDateWithYear,
        departureAirportCode: flightDeatils.departureAirportCode,
        arrivalAirportCode: flightDeatils.arrivalAirportCode,
        cabinPrefrences: flightDeatils.economyType,
        flightType: flightDeatils.flightType,
        flightRef: flightDeatils.flightRef
      };
      flightsDetails.push(this.flightDeatils);
    });
    return flightsDetails;
  }
  async GetReshopOffers() {
    let yourBookingScreenDetail = this.sandboxPageStateService.getYourBookingScreenData();
    let bookingDetail = yourBookingScreenDetail.booking;
    let jsonRequest = '';
    let findOrderScreenRequest = {} as FindOrderScreenRequest;
    let createOrderScreenRequest = {} as OfferPriceScreenOrderCreateRequest;
    let orderRepriceRequest = {} as ChangeDatetimeReshopReprice;
    if (yourBookingScreenDetail.bookingType === 'pre-booking') {
      jsonRequest = this.sandboxPageStateService.getJsonRequestFromMap(this.sandboxPageStateService.OFFER_PRICE_SCREEN_ORDER_CREATE_URL);
      createOrderScreenRequest = JSON.parse(jsonRequest);
    } else if (yourBookingScreenDetail.bookingType === 'post-booking') {
      jsonRequest = this.sandboxPageStateService.getJsonRequestFromMap(this.sandboxPageStateService.FIND_ORDER_SCREEN_URL);
      findOrderScreenRequest = JSON.parse(jsonRequest);
    } else if (yourBookingScreenDetail.bookingType === 'post-booking-reshop') {
      jsonRequest = this.sandboxPageStateService.getJsonRequestFromMap(this.sandboxPageStateService.CHANGE_BOOKING_ORDER_REPRICE_URL);
      orderRepriceRequest = JSON.parse(jsonRequest);
    }
    let jsonRequestTemplate = await this.localAssetReaderService.getContent(this.sandboxPageStateService.CHANGE_BOOKING_RESHOP_TEMPLATE);
    //const airlineOffersScreenRequest: AirlineOffersScreenRequest = JSON.parse(jsonRequest);
    this.orderChangeChangeDatetimeRQ = JSON.parse(jsonRequestTemplate as any);

    let pnr = bookingDetail?.pnrNumber;
    this.orderChangeChangeDatetimeRQ['S:Envelope'].$!['xmlns:S'] = 'http://schemas.xmlsoap.org/soap/envelope/';
    this.orderChangeChangeDatetimeRQ['S:Envelope'].$!['xmlns:SOAP-ENV'] = 'http://schemas.xmlsoap.org/soap/envelope/';
    this.orderChangeChangeDatetimeRQ['S:Envelope']['SOAP-ENV:Header'] = '';
    this.orderChangeChangeDatetimeRQ['S:Envelope']['S:Body']!.OrderReshopRQ.$['xmlns:xsd'] = 'http://www.w3.org/2001/XMLSchema';
    this.orderChangeChangeDatetimeRQ['S:Envelope']['S:Body']!.OrderReshopRQ.$['xmlns:xsi'] = 'http://www.w3.org/2001/XMLSchema-instance';
    this.orderChangeChangeDatetimeRQ['S:Envelope']['S:Body']!.OrderReshopRQ.$.xmlns = 'http://www.iata.org/IATA/EDIST/2017.2';
    this.orderChangeChangeDatetimeRQ['S:Envelope']['S:Body']!.OrderReshopRQ.$.Version = '17.2';
    //this.orderChangeChangeDatetimeRQ['S:Envelope']['S:Body']!.OrderReshopRQ.Party = airlineOffersScreenRequest['S:Envelope']['S:Body']?.OfferPriceRQ.Party;
    //this.orderChangeChangeDatetimeRQ['S:Envelope']['S:Body']!.OrderReshopRQ.Document = airlineOffersScreenRequest['S:Envelope']['S:Body']?.OfferPriceRQ.Document;
    this.orderChangeChangeDatetimeRQ['S:Envelope']['S:Body']!.OrderReshopRQ.DataLists.PassengerList.Passenger = [];
    this.orderChangeChangeDatetimeRQ['S:Envelope']['S:Body']!.OrderReshopRQ.Query.OrderID = pnr;
    this.loadPassengerDetail();
    this.mapAddOriginDestination(this.orderChangeChangeDatetimeRQ);
    this.mapOrderItemsForDelete();
    await this.apiService.getXMLResponse(this.sandboxPageStateService.REQUOTE_REQUEST_SCREEN_URL, JSON.stringify(this.orderChangeChangeDatetimeRQ), this.inputParamsMap, {
      headers: new HttpHeaders({
        soapAction: 'OrderReshop17_2_V3'
      }),
      responseType: 'text'
    });
    this.updatechangeBookingScreenXML(this.sandboxPageStateService.REQUOTE_REQUEST_SCREEN_URL);
  }
  loadPassengerDetail() {
    let passengerRefNumber = '';
    let passengerScreenDetail = this.sandboxPageStateService.getPassengerScreenDetail();
    let passengerDetail = passengerScreenDetail.passengerDetail;
    let passengerDetailLength: any = passengerDetail.length;
    if (passengerDetailLength > 0) {
      passengerDetail?.forEach((passenger: changeBookingPassenger) => {
        let passengerId = passenger.passengerId;
        let passengerDetail: orderReshopPassenger = {
          $: {
            PassengerID: passengerId
          },
          PTC: passenger.passengerType,
          Birthdate: passenger.passengerDOB,
          Individual: {
            Gender: passenger.passengerGender,
            NameTitle: passenger.passengerNameTitle,
            GivenName: passenger.passengerName,
            Surname: passenger.passengerSurName
          }
        };

        passengerRefNumber += ' ' + passengerId;

        this.orderChangeChangeDatetimeRQ['S:Envelope']['S:Body']!.OrderReshopRQ['DataLists']['PassengerList']['Passenger'].push(passengerDetail);
        this.orderChangeChangeDatetimeRQ['S:Envelope']['S:Body']!.OrderReshopRQ.Query.Reshop.OrderServicing.Add.Passengers.PassengerReferences = passengerRefNumber;
      });
    }
  }
  mapAddOriginDestination(orderChangeChangeDatetimeRQ: any) {
    let yourBookingScreenDetail = this.sandboxPageStateService.getYourBookingScreenData();
    let passengerScreenDetail = this.sandboxPageStateService.getPassengerScreenDetail();
    let passengerDetail = passengerScreenDetail.passengerDetail;
    let passengerDetailLength: any = passengerDetail.length;
    let passengerReferenceString = '';
    let changeBookingFormValue = this.changeBookingForm.value.boundOffersArray;
    let selectedBooking: any = [];
    let originDestinationList: changeBookingOriginDestination[] = [];
    let CabinTypeList: CabinType[] = [];
    if (passengerDetailLength > 0) {
      passengerDetail?.forEach((passenger: changeBookingPassenger) => {
        passengerReferenceString += ' ' + passenger.passengerId;
      });
    }
    changeBookingFormValue.forEach((boundArray: any) => {
      if (boundArray.isBoundSelected) {
        selectedBooking.push(boundArray);
      }
    });
    selectedBooking.forEach((booking: any) => {
      let changeBookingOriginDestinations: changeBookingOriginDestination = {
        $: {
          OriginDestinationKey: booking.originDestinationKey
        },
        Departure: {
          AirportCode: booking.depatureAirportCode,
          Date: booking.depatureDate
        },
        Arrival: {
          AirportCode: booking.arrivalAirportCode
        }
      };
      originDestinationList.push(changeBookingOriginDestinations);
      if (booking.cabinPreference !== '0') {
        let cabin: CabinType = {
          Code: booking.cabinPreference,
          OriginDestinationReferences: booking.originDestinationKey
        };
        CabinTypeList.push(cabin);
      }
    });
    this.orderChangeChangeDatetimeRQ['S:Envelope']['S:Body']!.OrderReshopRQ.Query.Reshop.OrderServicing.Add.FlightQuery.OriginDestinations.OriginDestination = originDestinationList;

    if (CabinTypeList.length > 0) {
      this.orderChangeChangeDatetimeRQ['S:Envelope']['S:Body']!.OrderReshopRQ.Query.Reshop.OrderServicing.Add.Preference = {
        CabinPreferences: {
          CabinType: CabinTypeList
        }
      };
    } else {
      delete this.orderChangeChangeDatetimeRQ['S:Envelope']['S:Body']!.OrderReshopRQ.Query.Reshop.OrderServicing.Add.Preference;
    }
    this.orderChangeChangeDatetimeRQ['S:Envelope']['S:Body']!.OrderReshopRQ.Query.Reshop.OrderServicing.Add.Passengers.PassengerReferences = passengerReferenceString;
  }
  mapOrderItemsForDelete() {
    let yourBookingScreenDetail = this.sandboxPageStateService.getYourBookingScreenData();
    //let originDestinationDetails = yourBookingScreenDetail.booking?.OriginDestinationList;
    //let orderIdList = yourBookingScreenDetail.booking?.OrderItem;
    let orderIdList = yourBookingScreenDetail.booking?.seatOfferIdList;
    let orderIdListLength: any = orderIdList?.length;
    let serviceId: string[] = [];
    let orderItemArray: changeBookingOrderItem[] = [];
    let orderServiceId: string = '';
    let changeBookingFormValue = this.changeBookingForm.value.boundOffersArray;
    if (orderIdListLength > 0) {
      let boundsArrayLength = changeBookingFormValue.length;
      let bountCount = 0;
      changeBookingFormValue.forEach((boundArray: any) => {
        if (boundArray.isBoundSelected) {
          bountCount = bountCount + 1;
        }
      });
      if (bountCount < boundsArrayLength) {
        changeBookingFormValue.forEach((boundArray: any) => {
          if (!boundArray.isBoundSelected) {
            yourBookingScreenDetail.serviceList?.forEach((service: any) => {
              boundArray.airlineOffer.flightsDetails.forEach((flight: any) => {
                if (flight.flightRef === service.serviceRef) {
                  serviceId.push(service);
                }
              });
            });
          }
        });
        orderIdList?.forEach((orderId: any) => {
          orderServiceId = '';
          let orderIdSplitArray = orderId.split('-');
          serviceId.forEach((id: any) => {
            if (orderIdSplitArray.includes(id.passengerRef)) {
              orderServiceId += ' ' + id.serviceId;
            }
          });
          let orderIdItem: changeBookingOrderItem = {
            $: {
              OrderItemID: orderId
            },
            ServiceRetainRequestIDs: orderServiceId.trim()
          };
          orderItemArray.push(orderIdItem);
        });
      } else {
        orderIdList?.forEach((orderId: any) => {
          let orderIdItem: changeBookingOrderItem = {
            $: {
              OrderItemID: orderId
            }
          };
          orderItemArray.push(orderIdItem);
        });
      }
      this.orderItemArrayForDelete = orderItemArray;
      this.orderChangeChangeDatetimeRQ['S:Envelope']['S:Body']!.OrderReshopRQ.Query.Reshop.OrderServicing.Delete.OrderItem = orderItemArray;
    }
  }

  trackFn(index: any) {
    return index;
  }
  updatechangeBookingScreenXML(url: string) {
    let patchSandboxSourceData: any = '';
    let yourBookingScreenDetail = this.sandboxPageStateService.getYourBookingScreenData();
    let bookingDetail = yourBookingScreenDetail.booking;
    if (this.sandboxPageStateService.getErrorMessage() !== '') {
      patchSandboxSourceData = { showError: 'Yes', errorMessage: this.sandboxPageStateService.getErrorMessage() };
      this.sandboxPageStateService.updateSandboxDataSource(patchSandboxSourceData);
    } else {
      let changeBookingScreen: ChangeFlightDateTimeScreen = {} as ChangeFlightDateTimeScreen;
      this.changeYourBookingScreendeatils.reshopAirlineOffers = [];
      changeBookingScreen.reshopAirlineOffers = this.changeYourBookingScreendeatils.reshopAirlineOffers;
      changeBookingScreen.xml = this.sandboxPageStateService.getResponseFromMap(url);
      changeBookingScreen.jsonData = this.xmlToJsonParserService.parseXMLToJSON(changeBookingScreen.xml!);
      changeBookingScreen.pnr = bookingDetail.pnrNumber;
      changeBookingScreen.orderId = bookingDetail.OrderItem;
      changeBookingScreen.bookingStatus = bookingDetail.bookingStatus;

      this.sandboxPageStateService.updateChangeBookingScreenData(changeBookingScreen);
      this.mapReshopAirlineOffers(changeBookingScreen.jsonData);
    }
  }

  mapReshopAirlineOffers(reshopOffersJson: any) {
    let seatEnvelop = reshopOffersJson['SOAP:ENVELOPE'];
    let seatBody = seatEnvelop['SOAP:BODY'][0];
    let airShoppings = seatBody['ORDERRESHOPRS'][0].RESPONSE[0];
    this.changeYourBookingScreendeatils.responseID = airShoppings.RESHOPPINGRESPONSEID[0].RESPONSEID[0];
    this.airlineOfferScreenResponseId = airShoppings.RESHOPPINGRESPONSEID;
    let flightOffers = airShoppings.RESHOPOFFERS[0].RESHOPOFFER;
    let dataList = airShoppings['DATALISTS'][0];
    this.segmentList = dataList['FLIGHTLIST'][0]['FLIGHT'];
    let flightDetail = dataList['FLIGHTSEGMENTLIST'][0];
    this.flightList = flightDetail['FLIGHTSEGMENT'];
    this.priceClassList = dataList['PRICECLASSLIST'][0]['PRICECLASS'];
    this.fareList = [];
    if (typeof dataList['FARELIST'] !== 'undefined') {
      this.fareList = dataList['FARELIST'][0]['FAREGROUP'];
    }
    // return;
    //this.descriptionList = dataList['DESCRIPTIONLIST'][0]['DESCRIPTION'];
    this.mapPassenger(dataList['PASSENGERLIST'][0]['PASSENGER']);
    // this.mapBaggageIds(this.baggageList);
    // this.mapDescription(this.descriptionList);
    this.mapFareIds(this.fareList);
    this.mapPriceIds(this.priceClassList);
    this.mapFlightId(this.flightList);
    this.mapFlightSegmentIds(this.segmentList);
    this.mapAirlineOffers(flightOffers, 'ReShop');
  }
  mapPassenger(passengerList: any) {
    this.passengersList = [];
    let passengerLength = passengerList.length;
    if (passengerLength > 0) {
      passengerList.forEach((passenger: any) => {
        let passengerDetail: Passenger = {
          passengerType: passenger.PTC[0],
          passengerId: passenger.$.PASSENGERID,
          passengerDOB: passenger.INDIVIDUAL[0].BIRTHDATE[0]
        };
        this.passengersList.push(passengerDetail);
        if (passenger.PTC[0] === 'INF') {
          this.infantRefsIds.push(passengerDetail.passengerId);
        } else if (passenger.PTC[0] === 'ADT') {
          this.adultRefsIds.push(passengerDetail.passengerId);
        }
      });
    }
  }
  mapFareIds(fareList: any) {
    this.fareListIds = [];
    if (fareList.length > 0) {
      fareList.forEach((fare: any) => {
        this.fareListIds.push(fare.$.LISTKEY);
      });
    }
  }
  mapPriceIds(priceList: any) {
    this.priceClassListIds = [];
    this.priceListIds = [];
    if (priceList.length > 0) {
      priceList.forEach((price: any) => {
        this.priceListIds.push(price.$.PRICECLASSID);
        let flightNumber: any = {};
        flightNumber['id'] = [];
        price.CLASSOFSERVICE.forEach((priceClass: any) => {
          let ref = priceClass.$.REFS.split(' ')[0];
          flightNumber['id'].push(ref);
        });
        this.priceClassListIds.push(flightNumber);
      });
    }
  }
  mapFlightId(flightList: any) {
    this.flightListIds = [];
    if (flightList.length > 0) {
      flightList.forEach((flight: any) => {
        let flightName = flight.$.SEGMENTKEY;
        this.flightListIds.push(flightName);
      });
    }
  }

  mapFlightSegmentIds(flightSegmentList: any) {
    this.segmentListIds = [];
    if (flightSegmentList.length > 0) {
      flightSegmentList.forEach((flightSegment: any) => {
        this.segmentListIds.push(flightSegment.$.FLIGHTKEY);
      });
    }
  }
  mapAirlineOffers(flightOffers: any, offer: string) {
    if (flightOffers.length > 0) {
      let offerIndex = 0;
      flightOffers.forEach((flightOffer: any) => {
        const priceDetail = this.getPriceDetail(flightOffer);
        let fareDetail = flightOffer.ADDOFFERITEM[0].FAREDETAIL[0].FARECOMPONENT;
        let offerItem = flightOffer.ADDOFFERITEM[0];
        let serviceList = offerItem.SERVICE;
        let boundAirlineOfferDetail: BoundAirlineOffer[] = [];
        let serviceIndex: any = 0;
        serviceList.forEach((service: any) => {
          let flightRef = service.FLIGHTREFS[0];
          boundAirlineOfferDetail.push(this.getAirlineOfferBase(fareDetail, serviceIndex, flightRef, flightOffers));
          serviceIndex++;
        });
        let offerItemsList = flightOffer.ADDOFFERITEM;
        let offerItemLength = offerItemsList.length;
        let offerItems: OfferItems[] = [];
        if (offerItemLength > 0) {
          offerItemsList.forEach((offerItemList: any) => {
            let offerItem: OfferItems = {
              offerItemID: offerItemList.$.OFFERITEMID,
              passengerRefs: ''
            };
            let offerItemService = offerItemList.SERVICE;
            let offerItemServiceLength = offerItemService.length;
            if (offerItemServiceLength > 0) {
              offerItemService.forEach((itemService: any) => {
                offerItem.passengerRefs = itemService.PASSENGERREFS[0];
              });
            }
            offerItems.push(offerItem);
          });
        }
        let airlineOffer: AirlineOffer = {
          offerIndex: offerIndex,
          offerOwner: flightOffer.$.OWNER,
          offerId: flightOffer.$.OFFERID,
          offerItem: offerItems,
          boundAirlineOffer: boundAirlineOfferDetail,
          priceDetail: priceDetail
        };
        if (offer === 'ReShop') {
          this.changeYourBookingScreendeatils.reshopAirlineOffers.push(airlineOffer);
        } else {
          this.changeYourBookingScreendeatils.selectedOfferItem = airlineOffer;
        }

        offerIndex++;
      });
    }
  }
  getPriceDetail(flightOffer: any): PriceDetail {
    let price$ = flightOffer.TOTALPRICE[0].SIMPLECURRENCYPRICE[0];
    let priceDetail: PriceDetail = {
      price: price$._,
      currency: price$.$.CODE
    };
    return priceDetail;
  }
  getAirlineOfferBase(fareDetail: any, index: number, flightRef: any, flightOffers: any): AirlineOfferBase {
    let flightDetails: AirlineOfferFlightDetail[] = [];
    let segmentIndex: any = this.segmentListIds.indexOf(flightRef);
    let selRow = this.segmentList[segmentIndex];
    let flightIdss = selRow.SEGMENTREFERENCES[0];
    let flightArr = flightIdss.split(' ');
    let flightLen = flightArr.length;
    if (flightLen > 0) {
      flightArr.forEach((flight: any) => {
        const flightDetail = this.getFlightDetail(fareDetail, index, flight);
        if (flightDetail) {
          flightDetails.push(flightDetail);
        }
      });
    }
    return {
      flightDetails: flightDetails
    };
  }
  getFlightDetail(fareDetail: any, index: number, flight: any) {
    let flightNumber = flight;
    let upPriceClassRef = fareDetail[index].PRICECLASSREF[0];
    let priceListIndex = this.priceListIds.indexOf(upPriceClassRef);
    if (priceListIndex !== -1) {
      let priceClassFlightsArr = this.priceClassListIds[priceListIndex]['id'];
      let priceClassFlightIndex: any = priceClassFlightsArr.indexOf(flightNumber);
      if (priceClassFlightIndex !== -1) {
        let priceClassDetail = this.priceClassList[priceListIndex];
        let priceClassServiceArr = priceClassDetail.CLASSOFSERVICE;
        let priceClassServiceSelRow = priceClassServiceArr[priceClassFlightIndex];
        let fbCode = priceClassServiceSelRow.$.REFS.split(' ')[1];
        let fbCodeIndex: any = this.fareListIds.indexOf(fbCode);
        let fareListCode: any = '';
        let fareListFareCode: any = '';
        if (fbCodeIndex !== -1) {
          let selFareRow = this.fareList[fbCodeIndex];
          fareListCode = selFareRow.FAREBASISCODE[0].CODE[0];
          fareListFareCode = selFareRow.FARE[0].FARECODE[0];
        }
        let flightIndex: any = this.flightListIds.indexOf(flightNumber);
        let selRow = this.flightList[flightIndex];
        let depatureDetail = selRow.DEPARTURE[0];
        let arrivalDetail = selRow.ARRIVAL[0];
        let marketingCarrier = selRow.MARKETINGCARRIER[0];
        let operatingCarrier = selRow.OPERATINGCARRIER[0];
        let fDetail = selRow.FLIGHTDETAIL[0];
        let fDuriation = fDetail.FLIGHTDURATION[0].VALUE[0];
        let flightDetail: AirlineOfferFlightDetail = {
          opperatingCarrierName: operatingCarrier.NAME[0],
          departureDate: this.datePipe.transform(depatureDetail.DATE[0], 'dd-MMM'),
          departureDateWithYear: depatureDetail.DATE[0],
          departureTimeIn24H: depatureDetail.TIME[0],
          departureAirportName: depatureDetail.AIRPORTNAME[0],
          departureAirportCode: depatureDetail.AIRPORTCODE[0],
          arrivalDate: this.datePipe.transform(arrivalDetail.DATE[0], 'dd-MMM'),
          arrivalTimeIn24H: arrivalDetail.TIME[0],
          arrivalAirportName: arrivalDetail.AIRPORTNAME[0],
          arrivalAirportCode: arrivalDetail.AIRPORTCODE[0],
          airlineId: marketingCarrier.AIRLINEID[0],
          airlineNumber: marketingCarrier.FLIGHTNUMBER[0],
          airlineName: typeof marketingCarrier.NAME !== 'undefined' ? marketingCarrier.NAME[0] : 'British Airways',
          duriation: fDuriation.slice(2),
          economyType: priceClassDetail.NAME[0],
          marketingName: priceClassDetail.CLASSOFSERVICE[0].MARKETINGNAME[0]._,
          ClassOfServiceCode: priceClassServiceSelRow.CODE[0]._ ? priceClassServiceSelRow.CODE[0]._ : priceClassServiceSelRow.CODE[0],
          flightType: priceClassServiceSelRow.CODE[0]._,
          flightCode1: fareListCode,
          flightCode2: fareListFareCode,
          fbcode: fbCode,
          actualDepatureDate: depatureDetail.DATE[0],
          actualArrivalDate: arrivalDetail.DATE[0]
        };
        return flightDetail;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }
  getFlightLogoUrl(airlineName: string) {
    const flightLogoUrl = this.flightLogoMap.get(airlineName);
    if (flightLogoUrl) {
      return flightLogoUrl;
    }
    return '';
  }
  roundOffAirlinePriceDetails(value: string): string {
    let priceData = parseFloat(value);
    return priceData.toFixed(2);
  }
  async getSelectedOfferPrice(offerIndex: any) {
    let yourBookingScreenData = this.sandboxPageStateService.getYourBookingScreenData();
    if (yourBookingScreenData.booking.isDisrupted) {
      this.initChangeDateTimeOrderChangeBooking(offerIndex);
    } else {
      let changeBookingData: ChangeFlightDateTimeScreen = this.sandboxPageStateService.getChangeBookingScreenData();
      let responseID = changeBookingData.responseID;
      let selectedOffer = changeBookingData.reshopAirlineOffers[offerIndex];
      this.initOrderRepriceRequest(selectedOffer, responseID);
    }
  }
  async initChangeDateTimeOrderChangeBooking(offerIndex: any) {
    let changeBookingData: ChangeFlightDateTimeScreen = this.sandboxPageStateService.getChangeBookingScreenData();
    let responseID: any = this.changeYourBookingScreendeatils.responseID;
    let selectedOffer = changeBookingData.reshopAirlineOffers[offerIndex];

    let yourBookingScreenDetail = this.sandboxPageStateService.getYourBookingScreenData();

    let bookingDetail = yourBookingScreenDetail.booking;
    let pnr = bookingDetail?.pnrNumber;
    let jsonRequestTemplate = await this.localAssetReaderService.getContent(this.sandboxPageStateService.ORDERCHANGE_CHANGE_DATE_TIME_BOOKING_REQUEST_TEMPLATE);
    this.orderChangeChangeDateTime = JSON.parse(jsonRequestTemplate as any);
    this.orderChangeChangeDateTime['S:Envelope'].$!['xmlns:S'] = 'http://schemas.xmlsoap.org/soap/envelope/';
    this.orderChangeChangeDateTime['S:Envelope'].$!['xmlns:SOAP-ENV'] = 'http://schemas.xmlsoap.org/soap/envelope/';
    this.orderChangeChangeDateTime['S:Envelope']['SOAP-ENV:Header'] = '';
    this.orderChangeChangeDateTime['S:Envelope']['S:Body']!.OrderChangeRQ.$['xmlns:xsd'] = 'http://www.w3.org/2001/XMLSchema';
    this.orderChangeChangeDateTime['S:Envelope']['S:Body']!.OrderChangeRQ.$['xmlns:xsi'] = 'http://www.w3.org/2001/XMLSchema-instance';
    this.orderChangeChangeDateTime['S:Envelope']['S:Body']!.OrderChangeRQ.$.xmlns = 'http://www.iata.org/IATA/EDIST/2017.2';
    this.orderChangeChangeDateTime['S:Envelope']['S:Body']!.OrderChangeRQ.$.Version = '17.2';
    this.orderChangeChangeDateTime['S:Envelope']['S:Body'].OrderChangeRQ.PointOfSale = '';
    this.orderChangeChangeDateTime['S:Envelope']['S:Body'].OrderChangeRQ.Query.OrderID = pnr;
    let previousSelectedOffer: any = [];
    yourBookingScreenDetail.booking.seatOfferIdList?.forEach((offer: any) => {
      previousSelectedOffer.push(offer);
    });
    this.orderChangeChangeDateTime['S:Envelope']['S:Body'].OrderChangeRQ.Query.OrderServicing.Delete.OrderItemID = previousSelectedOffer;
    this.orderChangeChangeDateTime['S:Envelope']['S:Body'].OrderChangeRQ.Query.OrderServicing.AcceptOffer.Offer = {
      $: {
        OfferID: selectedOffer.offerId,
        Owner: selectedOffer.offerOwner,
        ResponseID: responseID
      },
      OfferItem: this.getOfferItems(offerIndex)
    };
    delete this.orderChangeChangeDateTime['S:Envelope']['S:Body'].OrderChangeRQ.Query.Payments;
    this.loadReshopPassengerDetail();
    await this.apiService.getXMLResponse(this.sandboxPageStateService.ORDER_CHANGE_URL, JSON.stringify(this.orderChangeChangeDateTime), this.reQuoteTicketInputParamsMap, {
      headers: new HttpHeaders({
        soapAction: 'OrderChange17_2_V4'
      }),
      responseType: 'text'
    });
    this.updateOrderChangeXMLResponse(this.sandboxPageStateService.ORDER_CHANGE_URL);
  }
  updateOrderChangeXMLResponse(url: any) {
    let patchSandboxSourceData: any = '';
    if (this.sandboxPageStateService.getErrorMessage() !== '') {
      patchSandboxSourceData = { showError: 'Yes', errorMessage: this.sandboxPageStateService.getErrorMessage() };
      this.sandboxPageStateService.updateSandboxDataSource(patchSandboxSourceData);
    } else {
      let yourBookingScreenData = this.sandboxPageStateService.getYourBookingScreenData();
      yourBookingScreenData.isMapped = false;
      yourBookingScreenData.xml = this.sandboxPageStateService.getResponseFromMap(url);
      yourBookingScreenData.jsonData = this.xmlToJsonParserService.parseXMLToJSON(yourBookingScreenData.xml!);
      yourBookingScreenData.displayConfirmBookingForm = false;
      if (yourBookingScreenData.bookingType === 'post-booking-reshop') {
        yourBookingScreenData.bookingType = 'post-booking';
      }
      this.sandboxPageStateService.updateYourBookingScreenData(yourBookingScreenData);

      let addAnclilliariesScreenData = {} as AddAncilliariesScreen;
      this.sandboxPageStateService.updateAddAncilliariesScreenData(addAnclilliariesScreenData);

      patchSandboxSourceData = { mainMenu: 'none' };
      if (this.sandboxPageStateService.getWarningMessage() !== '') {
        patchSandboxSourceData['showWarning'] = 'Yes';
        patchSandboxSourceData['warningMessage'] = this.sandboxPageStateService.getWarningMessage();
      }
      this.sandboxPageStateService.updateSandboxDataSource(patchSandboxSourceData);

      this.triggerOcnMessage('ACTIONED');
      setTimeout(() => {
        let patchSandboxSourceData: any = '';
        patchSandboxSourceData = { mainMenu: 'your-booking-screen' };
        this.sandboxPageStateService.updateSandboxDataSource(patchSandboxSourceData);
      }, 200);
    }
  }
  capitalizeFirstLetter(words: any) {
    const result = words.charAt(0).toUpperCase() + words.slice(1).toLowerCase();
    return result;
  }
  loadReshopPassengerDetail() {
    let selectedPasengerIndex: any = 0;
    let passengerDetails: ReshopPassenger[] = [];

    let passengerScreenDetail = this.sandboxPageStateService.getPassengerScreenDetail();
    let passengerDetail = passengerScreenDetail.passengerDetail;
    let passengerDetailLength: any = passengerDetail.length;
    if (passengerDetailLength > 0) {
      let passengerIndex: any = 0;
      passengerDetail?.forEach((passenger: PassengerDetailSceenPassenger) => {
        let passengerId = passenger.passengerId;
        let passengerDetail = {} as ReshopPassenger;
        passengerDetail.$ = {
          PassengerID: passengerId
        };
        passengerDetail.PTC = passenger.passengerType;
        // if (typeof passenger.residenceCountryCode !== 'undefined') {
        //   passengerDetail.ResidenceCountryCode = passenger.residenceCountryCode;
        // }
        // if (typeof passenger.cityzenShipCode !== 'undefined') {
        //   passengerDetail.CitizenshipCountryCode = passenger.cityzenShipCode;
        // }
        passengerDetail.Individual = {
          Birthdate: passenger.passengerDOB,
          Gender: passenger.passengerGender,
          NameTitle: this.capitalizeFirstLetter(passenger.passengerNameTitle),
          GivenName: passenger.passengerName,
          Surname: passenger.passengerSurName
        };
        if (passenger.loyaltyProgramNumber) {
          passengerDetail.LoyaltyProgramAccount = {
            ProgramName: passenger.loyaltyProgram,
            AccountNumber: passenger.loyaltyProgramNumber
          };
        }
        if (passenger.idnumber) {
          passengerDetail.IdentityDocument = [
            {
              IdentityDocumentNumber: passenger.idnumber,
              IdentityDocumentType: passenger.identity,
              IssuingCountryCode: passenger.issuingCountry,
              CitizenshipCountryCode: passenger.cityzenShipCode,

              ExpiryDate: passenger.expiryDate,
              Birthdate: passenger.passengerDOB,
              Gender: passenger.passengerGender
            }
          ];
          if (passenger.redressNumber !== '' && passenger.redressNumber !== null && typeof passenger.redressNumber !== 'undefined') {
            passengerDetail.IdentityDocument.push({
              IdentityDocumentNumber: passenger.redressNumber,
              IdentityDocumentType: 'AEA',
              IssuingCountryCode: passenger.issuingCountry
            });
          }
        }
        passengerDetails.push(passengerDetail);
        passengerIndex++;
      });
      this.orderChangeChangeDateTime['S:Envelope']['S:Body'].OrderChangeRQ.DataLists.PassengerList.Passenger = passengerDetails;
    }
  }
  getOfferItems(offerIndex: any) {
    let changeBookingData: ChangeFlightDateTimeScreen = this.sandboxPageStateService.getChangeBookingScreenData();
    let responseID = changeBookingData.responseID;
    let selectedOffer = changeBookingData.reshopAirlineOffers[offerIndex];
    let changeBookingRepriceOffers = selectedOffer.offerItem;
    let offers: changeBookingOfferItem[] = [];
    if (changeBookingRepriceOffers.length > 0) {
      changeBookingRepriceOffers.forEach((offer: any) => {
        let offerItem = {
          $: {
            OfferItemID: offer.offerItemID
          },
          PassengerRefs: offer.passengerRefs
        };
        offers.push(offerItem);
      });
    }
    return offers;
  }
  async initOrderRepriceRequest(selectedOffer: AirlineOffer, responseID: string) {
    let yourBookingScreenDetail = this.sandboxPageStateService.getYourBookingScreenData();
    let bookingDetail = yourBookingScreenDetail.booking;
    let pnr = bookingDetail?.pnrNumber;
    let passengerScreenDetail = this.sandboxPageStateService.getPassengerScreenDetail();
    let passengerDetail = passengerScreenDetail.passengerDetail;
    let passengerDetailLength: any = passengerDetail.length;
    let jsonRequestTemplate = await this.localAssetReaderService.getContent(this.sandboxPageStateService.CHANGE_BOOKING_REPRICE_TEMPLATE);
    this.changeBookingRepriceRQ = JSON.parse(jsonRequestTemplate as any);
    this.changeBookingRepriceRQ['S:Envelope'].$!['xmlns:S'] = 'http://schemas.xmlsoap.org/soap/envelope/';
    this.changeBookingRepriceRQ['S:Envelope'].$!['xmlns:SOAP-ENV'] = 'http://schemas.xmlsoap.org/soap/envelope/';
    this.changeBookingRepriceRQ['S:Envelope']['SOAP-ENV:Header'] = '';
    this.changeBookingRepriceRQ['S:Envelope']['S:Body']!.OrderReshopRQ.$['xmlns:xsd'] = 'http://www.w3.org/2001/XMLSchema';
    this.changeBookingRepriceRQ['S:Envelope']['S:Body']!.OrderReshopRQ.$['xmlns:xsi'] = 'http://www.w3.org/2001/XMLSchema-instance';
    this.changeBookingRepriceRQ['S:Envelope']['S:Body']!.OrderReshopRQ.$.xmlns = 'http://www.iata.org/IATA/EDIST/2017.2';
    this.changeBookingRepriceRQ['S:Envelope']['S:Body']!.OrderReshopRQ.$.Version = '17.2';
    this.orderChangeChangeDatetimeRQ['S:Envelope']['S:Body']!.OrderReshopRQ.$['xmlns:xsd'] = 'http://www.w3.org/2001/XMLSchema';
    this.changeBookingRepriceRQ['S:Envelope']['S:Body']!.OrderReshopRQ.Query.OrderID = pnr;

    this.changeBookingRepriceRQ['S:Envelope']['S:Body']!.OrderReshopRQ.Query.Reshop.OrderServicing.Add.Qualifier.ExistingOrderQualifier.OrderKeys = {
      OrderID: {
        $: {
          Owner: selectedOffer.offerOwner
        },
        _: pnr
      },
      AssociatedIDs: {
        AssociatedID: this.mapAssociatedOfferItems(selectedOffer)
      }
    };
    let passengerReferenceString = '';
    if (passengerDetailLength > 0) {
      passengerDetail?.forEach((passenger: changeBookingPassenger) => {
        let passengerId = passenger.passengerId;
        let rePricePassengerDetail: orderRePricePassenger = {
          $: {
            PassengerID: passengerId
          },
          PTC: passenger.passengerType,
          Birthdate: passenger.passengerDOB,
          Individual: {
            Gender: passenger.passengerGender,
            NameTitle: passenger.passengerNameTitle,
            GivenName: passenger.passengerName,
            Surname: passenger.passengerSurName
          }
        };
        passengerReferenceString += ' ' + passenger.passengerId;
        this.changeBookingRepriceRQ['S:Envelope']['S:Body']!.OrderReshopRQ['DataLists']['PassengerList']['Passenger'].push(rePricePassengerDetail);
      });
      this.changeBookingRepriceRQ['S:Envelope']['S:Body']!.OrderReshopRQ.Query.Reshop.OrderServicing.Add.Qualifier.ExistingOrderQualifier.PassengerReferences = passengerReferenceString;
    }
    await this.apiService.getXMLResponse(
      this.sandboxPageStateService.CHANGE_BOOKING_ORDER_REPRICE_URL,
      JSON.stringify(this.changeBookingRepriceRQ),
      this.inputParamsMap,
      {
        headers: new HttpHeaders({
          soapAction: 'OrderReshop17_2_V3'
        }),
        responseType: 'text'
      },
      'OrderReshop#OrderReprice'
    );
    this.updateYourBookingScreenXML(this.sandboxPageStateService.CHANGE_BOOKING_ORDER_REPRICE_URL, selectedOffer);
  }

  changeDateTImecreenCloseClick() {
    let patchSandboxSourceData = { mainMenu: 'your-booking-screen' };
    this.sandboxPageStateService.updateSandboxDataSource(patchSandboxSourceData);
  }

  mapAssociatedOfferItems(selectedOffer: AirlineOffer) {
    let offerItemList: AssociatedID[] = [];
    selectedOffer.offerItem.forEach((offer: any) => {
      let offerItem = {
        OfferItemID: {
          $: {
            Owner: selectedOffer.offerOwner
          },
          _: offer.offerItemID
        }
      };
      offerItemList.push(offerItem);
    });
    return offerItemList;
  }
  updateYourBookingScreenXML(url: string, selectedOffer: AirlineOffer) {
    if (this.sandboxPageStateService.getErrorMessage() !== '') {
      let patchSandboxSourceData = { showError: 'Yes', errorMessage: this.sandboxPageStateService.getErrorMessage() };
      this.sandboxPageStateService.updateSandboxDataSource(patchSandboxSourceData);
    } else {
      let changeDateTimeRepriceScreenData = this.sandboxPageStateService.getChangeBookingScreenData();
      let yourBookingData = this.sandboxPageStateService.getYourBookingScreenData();
      let bookingDetails = yourBookingData.booking;
      changeDateTimeRepriceScreenData.orderRepriceXML = this.sandboxPageStateService.getResponseFromMap(url);
      changeDateTimeRepriceScreenData.orderRepriceJSON = this.xmlToJsonParserService.parseXMLToJSON(changeDateTimeRepriceScreenData.orderRepriceXML!);
      let seatEnvelop = changeDateTimeRepriceScreenData.orderRepriceJSON['SOAP:ENVELOPE'];
      let seatBody = seatEnvelop['SOAP:BODY'][0];
      let airShoppings = seatBody['ORDERRESHOPRS'][0].RESPONSE[0];
      this.changeYourBookingScreendeatils.responseID = airShoppings.RESHOPPINGRESPONSEID;
      this.airlineOfferScreenResponseId = airShoppings.RESHOPPINGRESPONSEID;
      let flightOffers = airShoppings.RESHOPOFFERS[0].RESHOPOFFER;
      this.mapAirlineOffers(flightOffers, 'RePrice');
      changeDateTimeRepriceScreenData.selectedOfferItem = this.changeYourBookingScreendeatils.selectedOfferItem;
      //changeDateTimeRepriceScreenData.selectedOfferItem = selectedOffer;
      changeDateTimeRepriceScreenData.responseID =
        changeDateTimeRepriceScreenData.orderRepriceJSON['SOAP:ENVELOPE']['SOAP:BODY'][0]['ORDERRESHOPRS'][0]['RESPONSE'][0]['RESHOPPINGRESPONSEID'][0]['RESPONSEID'][0];
      changeDateTimeRepriceScreenData.seatOfferIdList = bookingDetails.seatOfferIdList;
      this.sandboxPageStateService.updateChangeBookingScreenData(changeDateTimeRepriceScreenData);
      // let yourBookingScreenData = this.sandboxPageStateService.getYourBookingScreenData();
      let yourBookingScreen: YourBookingScreen = {} as YourBookingScreen;
      yourBookingScreen.xml = this.sandboxPageStateService.getResponseFromMap(url);
      yourBookingScreen.jsonData = this.xmlToJsonParserService.parseXMLToJSON(yourBookingScreen.xml!);
      yourBookingScreen.bookingType = 'post-booking-reshop';
      yourBookingScreen.booking = bookingDetails;
      let totalPrice = 0;
      let totalTax = 0;
      let totalBasePrice = 0;
      let currencyCode = '';
      this.offerPriceDataList = changeDateTimeRepriceScreenData.orderRepriceJSON['SOAP:ENVELOPE']['SOAP:BODY'][0]['ORDERRESHOPRS'][0]['RESPONSE'][0]['DATALISTS'][0];
      let offerPricePassengersDetails = this.offerPriceDataList.PASSENGERLIST[0].PASSENGER;
      this.offerPricePricedOffer = changeDateTimeRepriceScreenData.orderRepriceJSON['SOAP:ENVELOPE']['SOAP:BODY'][0]['ORDERRESHOPRS'][0]['RESPONSE'][0]['RESHOPOFFERS'][0]['RESHOPOFFER'][0];
      let offerPricePassengerDetailsLength = offerPricePassengersDetails.length;
      let passengersDetailsArray: PassengerDetailsScreenPassenger[] = [];
      let pasengerCount = 0;
      if (offerPricePassengerDetailsLength > 0) {
        offerPricePassengersDetails.forEach((passenger: any) => {
          let passengerId = passenger.$.PASSENGERID;
          let basePrice = 0;
          let tax = 0;
          let price = 0;
          let currency: any = '';
          //mapping price for customer
          let offerList = this.offerPricePricedOffer.ADDOFFERITEM;
          let offerListLength = offerList.length;
          if (offerListLength > 0) {
            let allowToAddPrice: boolean = true;
            offerList.forEach((offerList: any) => {
              let service = offerList.SERVICE;
              let serviceLength = service.length;
              if (serviceLength > 0) {
                service.forEach((serviceData: any) => {
                  if (allowToAddPrice) {
                    let passengerRefs = serviceData.PASSENGERREFS[0].split(' ');
                    let serviceAvilableForpassenger: any = passengerRefs.indexOf(passengerId);
                    if (typeof serviceAvilableForpassenger !== 'undefined' && serviceAvilableForpassenger !== -1) {
                      let servicePriceDetail = offerList.FAREDETAIL[0].PRICE[0];
                      basePrice += +servicePriceDetail.BASEAMOUNT[0]._;
                      tax += +servicePriceDetail.TAXES[0].TOTAL[0]._;
                      price += +servicePriceDetail.TOTALAMOUNT[0].SIMPLECURRENCYPRICE[0]._;
                      currency = servicePriceDetail.TOTALAMOUNT[0].SIMPLECURRENCYPRICE[0].$.CODE;
                      allowToAddPrice = false;
                      totalPrice += +price;
                      totalTax += +tax;
                      currencyCode = currency;
                      totalBasePrice += +servicePriceDetail.BASEAMOUNT[0]._;
                    }
                  }
                });
              }
            });
          }
          //end
          let passengerDetailsItem: PassengerDetailsScreenPassenger = {
            passengerOtherDetails: {
              passengerTicketDetails: [],
              passengerBaggageDetails: [],
              passengerSeatDetails: [],
              passengerMealDetails: [],
              passengerDisablityServiceDetail: [],
              passengerProductClimateServiceDetail: [],
              passengerSelectedBaggageDetail: [],
              passengerSelectedMealDetails: [],
              passengerSelectedDisablityServiceDetail: [],
              passengerSelectedSeatDetails: [],
              passengerSelectedProductClimateServiceDetail: []
            },
            basePrice: basePrice,
            taxPrice: tax,
            totalPrice: price,
            currency: currency,
            flightPrice: basePrice,
            flightTax: tax,
            flightTotal: price,
            flightCurrency: currency,
            passengerStatus: true,
            passengerName: passenger.INDIVIDUAL[0].GIVENNAME[0],
            passengerSurName: passenger.INDIVIDUAL[0].SURNAME[0],
            passengerGender: passenger.INDIVIDUAL[0].GENDER && passenger.INDIVIDUAL[0].GENDER[0],
            passengerNameTitle: passenger.INDIVIDUAL[0].NAMETITLE[0],
            passengerDOB: passenger.INDIVIDUAL[0].BIRTHDATE && passenger.INDIVIDUAL[0].BIRTHDATE[0],
            passengerType: passenger.PTC[0],
            passengerId: passengerId,
            residenceCountryCode: passenger.INDIVIDUAL[0].RESIDENCECOUNTRYCODE ? passenger.INDIVIDUAL[0].RESIDENCECOUNTRYCODE[0] : ''
          };
          if (typeof passenger.INFANTREF !== 'undefined') {
            passengerDetailsItem.infantRef = passenger.INFANTREF[0];
          }
          if (typeof passenger.CITIZENSHIPCOUNTRYCODE !== 'undefined') {
            passengerDetailsItem.cityzenShipCode = passenger.CITIZENSHIPCOUNTRYCODE[0];
          }
          passengersDetailsArray.push(passengerDetailsItem);
          pasengerCount++;
        });
      }
      this.passengerDetailScreen = {
        bookingPassengerDetailType: 'your-booking-screen-passenger',
        isMapped: true,
        passengerDetail: passengersDetailsArray,
        totalTax: totalTax,
        totalPrice: totalPrice,
        totalBasePrice: totalBasePrice,
        currency: currencyCode,
        activePassengerIndex: 0
      };

      yourBookingScreen.displayConfirmBookingForm = true;
      this.sandboxPageStateService.updateYourBookingScreenData(yourBookingScreen);
      this.sandboxPageStateService.updatePassengerDetailScreenData(this.passengerDetailScreen);
      let confimrmBookingScreenData = this.sandboxPageStateService.getConfirmBookingScreenData();
      confimrmBookingScreenData.bookingType = 'post-booking-reshop';
      if (changeDateTimeRepriceScreenData.bookingStatus === 'HOLD') {
        confimrmBookingScreenData.bookingType = 'post-booking-reshop-hold';
      }
      let rePricePriceDetails = changeDateTimeRepriceScreenData.orderRepriceJSON['SOAP:ENVELOPE']['SOAP:BODY'][0]['ORDERRESHOPRS'][0]['RESPONSE'][0]['RESHOPOFFERS'][0]['RESHOPOFFER'][0].TOTALPRICE;
      confimrmBookingScreenData.postBookingChangeDateTimeBookingDetail = {
        priceDetails: {
          flightPrice: totalPrice.toFixed(2),
          seatPrice: '0',
          bagPrice: '0',
          cardFee: '0',
          totalCharge: totalPrice.toFixed(2),
          priceCode: currencyCode
        }
      };
      if (totalPrice <= 0) {
        confimrmBookingScreenData.bookingType = 'post-booking-reshop-no-payment';
        this.triggerOcnMessage('ACTIONED');
      }

      this.sandboxPageStateService.updateConfirmBookingScreenData(confimrmBookingScreenData);
      let patchSandboxSourceData: any = { mainMenu: 'your-booking-screen' };
      this.sandboxPageStateService.updateSandboxDataSource(patchSandboxSourceData);
    }
  }

  triggerOcnMessage(status: 'ACTIONED' | 'CANCELLED') {
    let yourBookingData = this.sandboxPageStateService.getYourBookingScreenData();
    if (this.haveOcnNotificationDetail) {
      //this.initOCNMessageAPIRequest(findOrderScreenData.pnr,status);
      this.postUserInformation(status);
      // trigger api
      //trigger success
      yourBookingData.haveOcnNotificationDetail = false;
      this.sandboxPageStateService.updateFindOrderScreen(yourBookingData);
      this.haveOcnNotificationDetail = false;
      //trigger success end
      //trgger end
    }
  }

  async postUserInformation(status: 'ACTIONED' | 'CANCELLED') {
    let queryParams = new HttpParams();
    let body = [
      {
        pnr: this.selectedPNR,
        currentTimestamp: this.current_timestamp,
        changedBy: this.loggeduserMailID,
        userAction: 'Changed-Date-Time'
      }
    ];
    await this.apiService.sendPostRequest(body, '/update-ocn-messages');
  }
}
